class Unit {}

// type Either<L, R> = Left<L, R> | Right<L, R>;

export abstract class Either<L, R> {
  value?: L | R;

  constructor(value: L | R) {
    this.value = value;
  }

  // Represents the left side of [Either] class which by convention is a "Failure".
  get isLeft(): boolean {
    return this instanceof Left;
  }

  // Represents the right side of [Either] class which by convention is a "Success"
  get isRight(): boolean {
    return this instanceof Right;
  }

  get left(): L {
    return this.fold<L>(
      (value) => value,
      (_) => {
        throw new Error('Illegal use. You should check isLeft before calling');
      },
    );
  }

  get right(): R {
    return this.fold<R>(
      (left) => {
        throw Error('Illegal use. You should check isRight before calling');
      },
      (value) => value,
    );
  }

  abstract fold<T>(fnL: (left: L) => T, fnR: (right: R) => T): T;
}

// Represents the "Left" or "Failure" state
export class Left<L, R> extends Either<L, R> {
  constructor(override readonly value: L) {
    super(value);
  }

  override get isLeft(): boolean {
    return true;
  }

  override fold<T>(fnL: (left: L) => T, fnR: (right: R) => T): T {
    return fnL(this.value);
  }
}

// Represents the "Right" or "Success" state
export class Right<L, R> extends Either<L, R> {
  constructor(override readonly value: R) {
    super(value);
  }

  override get isRight(): boolean {
    return true;
  }

  override fold<T>(fnL: (left: L) => T, fnR: (right: R) => T): T {
    return fnR(this.value);
  }
}

// helper functions
export const unit = () => new Unit();
export const left = <L, R>(value: L): Left<L, R> => new Left(value);
export const right = <L, R>(value: R): Right<L, R> => new Right(value);
